<script setup lang="ts">
import type { CanvassListItem } from "@/canvasses/types";
import LinkListItem from "@/components/LinkListItem.vue";
import CanvassListItemDetails from "./CanvassListItemDetails.vue";

const { canvassListItem } = defineProps<{
  canvassListItem: CanvassListItem;
}>();
</script>

<template>
  <LinkListItem
    :to="{
      name: 'canvassFlowOverview',
      params: { canvassId: canvassListItem.id },
    }"
  >
    <template #header>
      <h3>
        {{ canvassListItem.name }}
      </h3>
    </template>
    <CanvassListItemDetails :canvass-list-item />
  </LinkListItem>
</template>
